import { defineComponent, h, ref, onMounted } from 'vue';
import { box } from '@/ui/components';
import { checkboxField } from '@/ui/components/form';
import { featureExplanationIcon } from '@/ui/components/icon/icons';
// @ts-ignore
import { t } from '@/ui/i18n/i18n';
import { getDefaultTitleSettings } from '@/_legacy/services/checklist';

interface Settings {
  node_id?: string|null;
  template_title: boolean;
  entity_item: boolean;
  conducted_by: boolean;
  conducted_at: boolean;
  submitted_id: boolean;
}

type SettingsWithoutNodeId = Omit<Settings, 'node_id'>;

interface TitleConfigurationProps {
  value: Settings;
}

export const TitleConfiguration = defineComponent<TitleConfigurationProps>({
  name: 'TitleConfiguration',
  props: ['value'],

  setup({ value }, { emit }) {
    const settings = ref<Settings>(getDefaultTitleSettings());

    onMounted(() => {
      if (value) {
        settings.value = value;
      }
    });

    const { node_id, ...settingsWithoutNodeId } = { ...settings.value };

    const getSelections = () => Object.keys(settingsWithoutNodeId).map(key => checkboxField(
      {
        name: key,
        label: t(`checklist.title-configuration.${key}`),
        value: settings.value[key as keyof SettingsWithoutNodeId],
        required: false,
        disabled: false,
        errors: [],
      },
      newVal => {
        settings.value = { ...settings.value, [key]: newVal };
        emit('input', settings.value);
      },
    ));

    return function render() {
      return h('div', { class: 'checklist-builder__title-configuration' }, [
        box([
          h('div', { class: 'checklist-builder__second-stage-title' }, t('checklist.title-configuration.title')),
          h('p', { class: 'checklist-builder__second-stage-description' }, t('checklist.title-configuration.description')),
          getSelections(),
          featureExplanationIcon({ size: 'sm' }),
          h('span', { class: 'checklist-builder__second-stage-description' }, t('checklist.title-configuration.warning')),
        ]),
      ]);
    };
  },
});
